import axios from "../../../utils/axios";
import {
    IVerifyPaymentLinkCodePayload,
    IProcessPaymentLinkPaymentPayload,
} from "../types/payment-link.types";

export async function getPaymentLinkDetails(ref: string, code?: string) {
    const response = await axios.get(`/payment-link/details`, {
        params: { ref, ...(code ? { code } : {}) },
    });
    return response.data;
}

export async function verifyPaymentLinkCode(
    payload: IVerifyPaymentLinkCodePayload
) {
    const response = await axios.post(`/payment-link/verify-code`, payload);
    return response.data;
}

export async function processPaymentLinkPayment(
    payload: IProcessPaymentLinkPaymentPayload
) {
    const response = await axios.post(`/payment-link/process-payment`, payload);
    return response.data;
}
